import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "mx-auto" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "space-y-8" }
const _hoisted_5 = { class: "flex space-x-6 text-sm rounded" }
const _hoisted_6 = { class: "flex justify-center w-full pt-4 bg-clay-50" }
const _hoisted_7 = { class: "w-full px-4 pt-4 space-y-6 sm:px-0" }
const _hoisted_8 = { class: "relative items-center max-w-5xl px-3 mx-auto space-x-3 space-y-1 md:flex md:px-0" }
const _hoisted_9 = { class: "flex-1 min-w-0" }
const _hoisted_10 = { class: "space-y-1" }
const _hoisted_11 = { class: "max-w-5xl pb-6 mx-auto md:flex md:items-center md:justify-between" }
const _hoisted_12 = { class: "items-center space-y-3 sm:-mx-4 sm:divide-x sm:divide-gray-200 md:flex md:space-y-0" }
const _hoisted_13 = {
  key: 0,
  class: "ml-1.5 font-semibold tabular-nums text-gray-700 hover:text-gray-900"
}
const _hoisted_14 = { class: "py-1" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "sm:block" }
const _hoisted_17 = { class: "flow-root" }
const _hoisted_18 = {
  key: 0,
  class: "ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-700 hover:bg-electric-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-700"
}
const _hoisted_19 = { class: "space-y-4" }
const _hoisted_20 = ["id", "value"]
const _hoisted_21 = ["for"]
const _hoisted_22 = {
  key: 0,
  class: "ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-700 hover:bg-electric-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-700"
}
const _hoisted_23 = { class: "space-y-4" }
const _hoisted_24 = ["id", "value"]
const _hoisted_25 = ["for"]
const _hoisted_26 = {
  key: 0,
  class: "ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-700 hover:bg-electric-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-700"
}
const _hoisted_27 = { class: "space-y-4" }
const _hoisted_28 = ["id", "value"]
const _hoisted_29 = ["for"]
const _hoisted_30 = {
  key: 0,
  class: "ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-700 hover:bg-electric-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-700"
}
const _hoisted_31 = { class: "space-y-4" }
const _hoisted_32 = ["id", "value"]
const _hoisted_33 = ["for"]
const _hoisted_34 = {
  key: 0,
  class: "ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-700 hover:bg-electric-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-700"
}
const _hoisted_35 = { class: "space-y-4" }
const _hoisted_36 = ["id", "value"]
const _hoisted_37 = ["for"]
const _hoisted_38 = {
  key: 0,
  class: "ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-700 hover:bg-electric-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-700"
}
const _hoisted_39 = { class: "space-y-4" }
const _hoisted_40 = { class: "flex items-center" }
const _hoisted_41 = { class: "flex items-center" }
const _hoisted_42 = { class: "flex items-center" }
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "max-w-6xl px-4 mx-auto sm:px-6 lg:px-8" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }

import {computed, defineComponent, ref, Ref, watch} from "vue";
import {client} from '@/shared';
import {
    SearchSongsByFiltersRequest,
    SearchSongsByFiltersResponse,
} from "@/dtos";
// @ts-ignore
import Paginate from "vuejs-paginate-next";
import {ArrowsUpDownIcon} from '@heroicons/vue/20/solid';
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import EmptyResultsNotification from "@/main/components/EmptyResultsNotification.vue";
// @ts-ignore
import {useDebounceFn} from "@vueuse/core";

import {
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems
} from '@headlessui/vue'

import {ChevronDownIcon} from '@heroicons/vue/20/solid'
import SongCard from "./SongCard.vue";
import WalledOffFilter from "../../Shared/WalledOffFilter.vue";

const nextHtml = `<span class="hidden md:inline-block">Next</span>
                        <svg class="w-5 h-5 ml-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

const prevHtml = `<svg class="w-5 h-5 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                        </svg>
                        <span class="hidden md:inline-block">Previous</span>`;



export default /*@__PURE__*/_defineComponent({
  __name: 'SearchSongs',
  props: {
    categoryOptions: Array,
    genderOptions: Array,
    voiceTypeOptions: Array,
    styleOptions: Array,
    ageRangeOptions: Array
},
  setup(__props) {

// @ts-ignore
const open = ref(false)
const queryText = ref('');

const props = __props;

const onQueryTextChanged = useDebounceFn(async () => {
    request.value.title = queryText.value;
}, 1000);

const sortOptions = [
    {text: 'Popular', value: 'Popular'},
    {text: 'Best Match', value: 'Best Match'}
];

const additionalOptions = computed(() => {
    let options = [];
    if (request.value.withVideo === true)
        options.push("video");
    if (request.value.hasContext === true)
        options.push("context");
    if (request.value.hasCutSuggestions === true)
        options.push("cut_suggestions");
    if (request.value.hasVocalNotes === true)
        options.push("vocal_notes");

    return options;
});

const shouldScroll = ref(false);
const songsRetrieved = ref(false);
const searchSongsByFilterResponse = ref(new SearchSongsByFiltersResponse());
const request = ref(new SearchSongsByFiltersRequest({
    categories: [],
    styles: [],
    genders: [],
    ageRanges: [],
    voiceTypes: [],
    withVideo: false,
    hasContext: true,
    hasVocalNotes: false,
    hasCutSuggestions: false,
    sort: 'Popular'
}));

const resultsSection = ref(null);

const filter = async () => {
    songsRetrieved.value = false;

    await client.get<SearchSongsByFiltersResponse>(request.value)
        .then(res => {
            songsRetrieved.value = true;
            searchSongsByFilterResponse.value = res;
            if(shouldScroll.value){
                resultsSection.value.scrollIntoView({
                    behavior: "smooth"
                });
            }
            shouldScroll.value = true;
        });
}

const resetFilters = async () => {
    request.value = new SearchSongsByFiltersRequest({
        categories: [],
        styles: [],
        genders: [],
        ageRanges: [],
        voiceTypes: [],
        withVideo: false,
        hasContext: true,
        hasVocalNotes: false,
        hasCutSuggestions: false,
        sort: 'Popular'
    });
}

const clickHandler = async (pageNum: any) => {
    request.value.currentPage = pageNum;
    await filter();
}

const getPageCount = () => {
    return Math.ceil(searchSongsByFilterResponse.value.totalResults / 12);
}

watch([
        () => request.value.title,
        () => request.value.categories,
        () => request.value.styles,
        () => request.value.genders,
        () => request.value.ageRanges,
        () => request.value.voiceTypes,
        () => request.value.withVideo,
        () => request.value.hasVocalNotes,
        () => request.value.hasContext,
        () => request.value.hasCutSuggestions,
        () => request.value.sort,
    ], async ([]) => {
        request.value.currentPage = 1;
        await filter();
    },
    { immediate: true }
);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[23] || (_cache[23] = _createElementVNode("div", {
        "aria-hidden": "true",
        class: "absolute inset-0 flex flex-col"
      }, [
        _createElementVNode("div", { class: "flex-1" }),
        _createElementVNode("div", { class: "flex-1 w-full" })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          id: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryText).value = $event)),
                          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onQueryTextChanged) && _unref(onQueryTextChanged)(...args))),
                          autofocus: "",
                          class: "block w-full rounded-md bg-white px-3 py-1.5 text-base text-clay-900 outline-1 -outline-offset-1 outline-clay-300 placeholder:text-clay-900 focus:outline-2 focus:-outline-offset-2 focus:outline-clay-600 sm:text-sm/6",
                          name: "name",
                          placeholder: "Filter by Song Title",
                          type: "text"
                        }, null, 544), [
                          [_vModelText, queryText.value]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_unref(Menu), {
                        as: "div",
                        class: "relative block text-center border border-clay-500 md:text-left md:inline-block sm:border-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_unref(MenuButton), { class: "inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ArrowsUpDownIcon), {
                                  class: "w-5 h-5 mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
                                  "aria-hidden": "true"
                                }),
                                (request.value.sort.length > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(request.value.sort), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-100 ease-out",
                            "enter-from-class": "transform scale-95 opacity-0",
                            "enter-to-class": "transform scale-100 opacity-100",
                            "leave-active-class": "transition duration-75 ease-in",
                            "leave-from-class": "transform scale-100 opacity-100",
                            "leave-to-class": "transform scale-95 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(MenuItems), { class: "z-10 mt-2 overflow-auto origin-top-left bg-white rounded-md shadow-2xl sm:absolute sm:left-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_14, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, (option) => {
                                      return _createVNode(_unref(MenuItem), {
                                        key: option.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("a", {
                                            class: _normalizeClass([option.value === request.value.sort ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm font-medium text-gray-900']),
                                            onClick: ($event: any) => (request.value.sort=option.value)
                                          }, _toDisplayString(option.text), 11, _hoisted_15)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    }), 64))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(PopoverGroup), { class: "items-center divide-x divide-gray-200 sm:-mx-4 sm:flex" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Popover), { class: "relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PopoverButton), { class: "inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0" }, {
                                  default: _withCtx(() => [
                                    _cache[12] || (_cache[12] = _createElementVNode("span", null, "Voice Type", -1)),
                                    (request.value.voiceTypes.length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(request.value.voiceTypes.length), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(ChevronDownIcon), {
                                      class: "w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
                                      "aria-hidden": "true"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_Transition, {
                                  "enter-active-class": "transition duration-100 ease-out",
                                  "enter-from-class": "transform scale-95 opacity-0",
                                  "enter-to-class": "transform scale-100 opacity-100",
                                  "leave-active-class": "transition duration-75 ease-in",
                                  "leave-from-class": "transform scale-100 opacity-100",
                                  "leave-to-class": "transform scale-95 opacity-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PopoverPanel), { class: "z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("form", _hoisted_19, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.voiceTypeOptions, (option) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: option,
                                              class: "flex items-center"
                                            }, [
                                              _withDirectives(_createElementVNode("input", {
                                                id: option.text,
                                                value: option.value,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((request.value.voiceTypes) = $event)),
                                                type: "checkbox",
                                                class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                              }, null, 8, _hoisted_20), [
                                                [_vModelCheckbox, request.value.voiceTypes]
                                              ]),
                                              _createElementVNode("label", {
                                                for: option.text,
                                                class: "pr-6 ml-3 text-sm font-medium text-gray-900 uppercase"
                                              }, _toDisplayString(option.text), 9, _hoisted_21)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Popover), { class: "relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PopoverButton), { class: "inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0" }, {
                                  default: _withCtx(() => [
                                    _cache[13] || (_cache[13] = _createElementVNode("span", null, "Style", -1)),
                                    (request.value.styles.length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(request.value.styles.length), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(ChevronDownIcon), {
                                      class: "w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
                                      "aria-hidden": "true"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_Transition, {
                                  "enter-active-class": "transition duration-100 ease-out",
                                  "enter-from-class": "transform scale-95 opacity-0",
                                  "enter-to-class": "transform scale-100 opacity-100",
                                  "leave-active-class": "transition duration-75 ease-in",
                                  "leave-from-class": "transform scale-100 opacity-100",
                                  "leave-to-class": "transform scale-95 opacity-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PopoverPanel), { class: "z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("form", _hoisted_23, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.styleOptions, (option) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: option.text,
                                              class: "flex items-center"
                                            }, [
                                              _withDirectives(_createElementVNode("input", {
                                                id: option.text,
                                                value: option.value,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((request.value.styles) = $event)),
                                                type: "checkbox",
                                                class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                              }, null, 8, _hoisted_24), [
                                                [_vModelCheckbox, request.value.styles]
                                              ]),
                                              _createElementVNode("label", {
                                                for: option.text,
                                                class: "pr-6 ml-3 text-sm font-medium text-gray-900 uppercase"
                                              }, _toDisplayString(option.text), 9, _hoisted_25)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Popover), { class: "relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PopoverButton), { class: "inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0" }, {
                                  default: _withCtx(() => [
                                    _cache[14] || (_cache[14] = _createElementVNode("span", null, "Category", -1)),
                                    (request.value.categories.length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(request.value.categories.length), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(ChevronDownIcon), {
                                      class: "w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
                                      "aria-hidden": "true"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_Transition, {
                                  "enter-active-class": "transition duration-100 ease-out",
                                  "enter-from-class": "transform scale-95 opacity-0",
                                  "enter-to-class": "transform scale-100 opacity-100",
                                  "leave-active-class": "transition duration-75 ease-in",
                                  "leave-from-class": "transform scale-100 opacity-100",
                                  "leave-to-class": "transform scale-95 opacity-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PopoverPanel), { class: "z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("form", _hoisted_27, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categoryOptions, (option) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: option,
                                              class: "flex items-center"
                                            }, [
                                              _withDirectives(_createElementVNode("input", {
                                                id: option.text,
                                                value: option.value,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((request.value.categories) = $event)),
                                                type: "checkbox",
                                                class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                              }, null, 8, _hoisted_28), [
                                                [_vModelCheckbox, request.value.categories]
                                              ]),
                                              _createElementVNode("label", {
                                                for: option.text,
                                                class: "pr-6 ml-3 text-sm font-medium text-gray-900 uppercase"
                                              }, _toDisplayString(option.text), 9, _hoisted_29)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Popover), { class: "relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PopoverButton), { class: "inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0" }, {
                                  default: _withCtx(() => [
                                    _cache[15] || (_cache[15] = _createElementVNode("span", null, "Gender", -1)),
                                    (request.value.genders.length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(request.value.genders.length), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(ChevronDownIcon), {
                                      class: "w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
                                      "aria-hidden": "true"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_Transition, {
                                  "enter-active-class": "transition duration-100 ease-out",
                                  "enter-from-class": "transform scale-95 opacity-0",
                                  "enter-to-class": "transform scale-100 opacity-100",
                                  "leave-active-class": "transition duration-75 ease-in",
                                  "leave-from-class": "transform scale-100 opacity-100",
                                  "leave-to-class": "transform scale-95 opacity-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PopoverPanel), { class: "z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80 md:w-48" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("form", _hoisted_31, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.genderOptions, (option) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: option.text,
                                              class: "flex items-center"
                                            }, [
                                              _withDirectives(_createElementVNode("input", {
                                                id: option.text,
                                                value: option.value,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((request.value.genders) = $event)),
                                                type: "checkbox",
                                                class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                              }, null, 8, _hoisted_32), [
                                                [_vModelCheckbox, request.value.genders]
                                              ]),
                                              _createElementVNode("label", {
                                                for: option.text,
                                                class: "pr-6 ml-3 text-sm font-medium text-gray-900 uppercase"
                                              }, _toDisplayString(option.text), 9, _hoisted_33)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(WalledOffFilter, {
                              "filter-title": "Playing Age",
                              "content-for": "ProOnly"
                            }, {
                              "content-title": _withCtx(() => _cache[16] || (_cache[16] = [
                                _createTextVNode(" to use the "),
                                _createElementVNode("em", null, "Playing Age", -1),
                                _createTextVNode(" filter and to unlock other amazing theatre resources! ")
                              ])),
                              pro: _withCtx(() => [
                                _createVNode(_unref(Popover), { class: "relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PopoverButton), { class: "inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0" }, {
                                      default: _withCtx(() => [
                                        _cache[17] || (_cache[17] = _createElementVNode("span", null, "Playing Age", -1)),
                                        (request.value.ageRanges.length > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(request.value.ageRanges.length), 1))
                                          : _createCommentVNode("", true),
                                        _createVNode(_unref(ChevronDownIcon), {
                                          class: "w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
                                          "aria-hidden": "true"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_Transition, {
                                      "enter-active-class": "transition duration-100 ease-out",
                                      "enter-from-class": "transform scale-95 opacity-0",
                                      "enter-to-class": "transform scale-100 opacity-100",
                                      "leave-active-class": "transition duration-75 ease-in",
                                      "leave-from-class": "transform scale-100 opacity-100",
                                      "leave-to-class": "transform scale-95 opacity-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PopoverPanel), { class: "z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80 md:w-72" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("form", _hoisted_35, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ageRangeOptions, (option) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: option.text,
                                                  class: "flex items-center"
                                                }, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    id: option.text,
                                                    value: option.value,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((request.value.ageRanges) = $event)),
                                                    type: "checkbox",
                                                    class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                                  }, null, 8, _hoisted_36), [
                                                    [_vModelCheckbox, request.value.ageRanges]
                                                  ]),
                                                  _createElementVNode("label", {
                                                    for: option.text,
                                                    class: "pr-6 ml-3 text-sm font-medium text-gray-900 uppercase"
                                                  }, _toDisplayString(option.text), 9, _hoisted_37)
                                                ]))
                                              }), 128))
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Popover), { class: "relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PopoverButton), { class: "inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0" }, {
                                  default: _withCtx(() => [
                                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "Additional", -1)),
                                    (additionalOptions.value.length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(additionalOptions.value.length), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(ChevronDownIcon), {
                                      class: "w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
                                      "aria-hidden": "true"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_Transition, {
                                  "enter-active-class": "transition duration-100 ease-out",
                                  "enter-from-class": "transform scale-95 opacity-0",
                                  "enter-to-class": "transform scale-100 opacity-100",
                                  "leave-active-class": "transition duration-75 ease-in",
                                  "leave-from-class": "transform scale-100 opacity-100",
                                  "leave-to-class": "transform scale-95 opacity-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PopoverPanel), { class: "z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("form", _hoisted_39, [
                                          _createElementVNode("div", _hoisted_40, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((request.value.withVideo) = $event)),
                                              type: "checkbox",
                                              class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                            }, null, 512), [
                                              [_vModelCheckbox, request.value.withVideo]
                                            ]),
                                            _cache[19] || (_cache[19] = _createElementVNode("label", {
                                              for: "withVideo",
                                              class: "pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap"
                                            }, "Video", -1))
                                          ]),
                                          _createElementVNode("div", _hoisted_41, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((request.value.hasVocalNotes) = $event)),
                                              type: "checkbox",
                                              class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                            }, null, 512), [
                                              [_vModelCheckbox, request.value.hasVocalNotes]
                                            ]),
                                            _cache[20] || (_cache[20] = _createElementVNode("label", {
                                              for: "hasVocalNotes",
                                              class: "pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap"
                                            }, "Vocal Notes", -1))
                                          ]),
                                          _createElementVNode("div", _hoisted_42, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((request.value.hasContext) = $event)),
                                              type: "checkbox",
                                              class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                            }, null, 512), [
                                              [_vModelCheckbox, request.value.hasContext]
                                            ]),
                                            _cache[21] || (_cache[21] = _createElementVNode("label", {
                                              for: "hasContext",
                                              class: "pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap"
                                            }, "Context", -1))
                                          ]),
                                          _createElementVNode("div", _hoisted_43, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((request.value.hasCutSuggestions) = $event)),
                                              type: "checkbox",
                                              class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500"
                                            }, null, 512), [
                                              [_vModelCheckbox, request.value.hasCutSuggestions]
                                            ]),
                                            _cache[22] || (_cache[22] = _createElementVNode("label", {
                                              for: "hasCutSuggestions",
                                              class: "pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap"
                                            }, "Cut Suggestions", -1))
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "resultsSection",
      ref: resultsSection,
      class: "min-h-screen py-8"
    }, [
      _createElementVNode("div", _hoisted_44, [
        (songsRetrieved.value === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              (searchSongsByFilterResponse.value.results?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSongsByFilterResponse.value.results, (song) => {
                        return (_openBlock(), _createBlock(SongCard, {
                          key: song.id,
                          song: song
                        }, null, 8, ["song"]))
                      }), 128))
                    ]),
                    _createVNode(_unref(Paginate), {
                      modelValue: searchSongsByFilterResponse.value.currentPage,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((searchSongsByFilterResponse.value.currentPage) = $event)),
                      "active-class": 'border border-electric-700 text-electric-700 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-bold border-x-0 border-b-0',
                      "click-handler": clickHandler,
                      "container-class": 'border-t border-gray-200 px-4 flex items-center justify-between sm:px-0 mt-8',
                      "margin-pages": 2,
                      "next-class": '-mt-px w-0 flex-1 flex justify-end',
                      "next-link-class": 'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-clay-900 hover:border-electric-700',
                      "next-text": nextHtml,
                      "page-class": 'hover:text-clay-900 hover:border-electric-700 hover:border-t-2 hover:border pt-4 px-4 inline-flex items-center text-sm font-medium dark:text-gray-400',
                      "page-count": getPageCount(),
                      "page-range": 3,
                      "prev-class": '-mt-px w-0 flex-1 flex',
                      "prev-link-class": 'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-clay-900 hover:border-electric-700',
                      "prev-text": prevHtml
                    }, null, 8, ["modelValue", "page-count"])
                  ]))
                : (_openBlock(), _createBlock(EmptyResultsNotification, { key: 1 }))
            ]))
          : (_openBlock(), _createBlock(SkeletonCard, {
              key: 1,
              "card-style": "long",
              "num-of-cards": 4
            }))
      ])
    ], 512)
  ], 64))
}
}

})